import sanitizeHtml from 'sanitize-html';
import { truncate } from 'lodash';

import type { MentionCardTextTypes } from 'types';

const SANITIZE_HTML_CONFIG = {
  allowedTags: ['span'],
  allowedAttributes: {
    span: ['class']
  }
};

const NUM_TEXT_ROWS_TO_SHOW = {
  caption: 4,
  videoTitle: 3,
  videoDescription: 5
};

export const CHARACTERS_PER_ROW = 30;

export const getWrappedSearchTerm = (searchTerm: string, className: string): string => `
  <div class="${className} text-overflow-ellipsis">
    ${searchTerm}
  </div>
`;

export const wrapSearchTermsKeywords = (searchTerms: Array<string>, className: string = ''): string => {
  const valuesToWrap = searchTerms.filter((term, index) => index > 0);
  const wrappedValues = valuesToWrap.map(searchTerm => getWrappedSearchTerm(searchTerm, className));

  return wrappedValues.join().replace(/,/g, '');
};

export const wrapSearchTermsText = (text: string, searchTerm: string, className: string = ''): string => {
  const termToReplace = new RegExp(`(^[#|@]?${searchTerm}$)`, 'gi');
  const textArray = text.split(/\s/);

  const wrappedTextArray = textArray.map(item => (
    item.replace(termToReplace, `<span class="${className}">$1</span>`)
  ));

  return wrappedTextArray.join(' ');
};

export const getEngagementRateValue = (engagementRate?: number | null): string => {
  const engagementRateFixed = engagementRate ? engagementRate.toFixed(1) : '0.0';

  return engagementRateFixed !== '0.0' ? engagementRateFixed : '0';
};

export const getCharacterCount = (type: MentionCardTextTypes, maxRowCount?: number | null): number => {
  const rowCount = NUM_TEXT_ROWS_TO_SHOW[type] || 5;

  return CHARACTERS_PER_ROW * (maxRowCount || rowCount);
};

export const getTruncatedValue = (
  value: string | undefined | null,
  maxRowCount: number | undefined | null,
  textType: MentionCardTextTypes
): string => truncate(value ?? '', { length: getCharacterCount(textType, maxRowCount) });

export const getSanitizedValue = (value: string): string => sanitizeHtml(value, SANITIZE_HTML_CONFIG);
